import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';

export const useApiInfo = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const getInfo = async () => {
    return runApi('info', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return '';
      } else {                
        return res.data;
      }
    });
  };

  return { getInfo };
};
